import e from"react";const a=a=>{const{className:t}=a;return e.createElement("div",{className:t||"loader"})};export{a as default};
